"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.years = exports.months = exports.days = void 0;
var _dayjs = _interopRequireDefault(require("dayjs"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const days = toDay => {
  const result = [];
  let i = 1;
  while (i <= toDay) {
    result.push({
      label: i.toString(),
      value: i.toString().padStart(2, '0')
    });
    i++;
  }
  return result;
};
exports.days = days;
const getMonth = number => (0, _dayjs.default)().month(number - 1).format('MMM').toUpperCase();
const months = exports.months = [{
  label: getMonth(1),
  value: '01'
}, {
  label: getMonth(2),
  value: '02'
}, {
  label: getMonth(3),
  value: '03'
}, {
  label: getMonth(4),
  value: '04'
}, {
  label: getMonth(5),
  value: '05'
}, {
  label: getMonth(6),
  value: '06'
}, {
  label: getMonth(7),
  value: '07'
}, {
  label: getMonth(8),
  value: '08'
}, {
  label: getMonth(9),
  value: '09'
}, {
  label: getMonth(10),
  value: '10'
}, {
  label: getMonth(11),
  value: '11'
}, {
  label: getMonth(12),
  value: '12'
}];
const buildYears = function (startYear) {
  let nextYears = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const currentYear = new Date().getFullYear(),
    years = [];
  startYear = startYear || currentYear - 90;
  while (startYear <= currentYear + nextYears) {
    const year = startYear++;
    years.push({
      label: year.toString(),
      value: year.toString()
    });
  }
  return years;
};
const years = nextYears => buildYears(undefined, nextYears).reverse();
exports.years = years;